/* tslint:disable */
/* eslint-disable */
/**
 * attachmentAV
 * An SDK to integrate virus and malware scan capabilities into JavaScript / TypeScript applications. Scan files for viruses, trojans, and other kinds of malware with attachmentAV powered by Sophos.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Whoami
 */
export interface Whoami {
    /**
     * 
     * @type {string}
     * @memberof Whoami
     */
    tenantId: string;
}

/**
 * Check if a given object implements the Whoami interface.
 */
export function instanceOfWhoami(value: object): value is Whoami {
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    return true;
}

export function WhoamiFromJSON(json: any): Whoami {
    return WhoamiFromJSONTyped(json, false);
}

export function WhoamiFromJSONTyped(json: any, ignoreDiscriminator: boolean): Whoami {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'],
    };
}

export function WhoamiToJSON(json: any): Whoami {
    return WhoamiToJSONTyped(json, false);
}

export function WhoamiToJSONTyped(value?: Whoami | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
    };
}

